import {
	FormControl,
	FormHelperText,
	Box,
	Icon,
	Image,
	Link,
	HStack,
	Spinner,
	Stack,
	Text,
	Heading,
	VStack,
} from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'
import 'react-phone-input-2/lib/style.css'
import { useSendCognitoOtp } from '../../../hooks/login.hooks'
import { AUTH_LOGIN_MODE } from '../../../utils/constant'
import { LS_LOGIN_MODE } from '../login.util'
import { EMAIL_FORM_VIEW } from './email.config'
import greneLogo from '../../../assets/images/grene-logo.png'
import { BsPhoneVibrate } from 'react-icons/bs'
import { AiOutlineWindows } from 'react-icons/ai'
import { LOGIN_MODE } from './../login.util'
import ButtonCTA from './../../globalComponents/button/index'
import InputText from './../../globalComponents/inputText/index'
import SVGIcon from '../../../assets/svgIcons'

export default function EmailInput({ onSendOtpSuccess, setLoginMode }) {
	const {
		handleSubmit,
		formState: { errors },
		register,
	} = useForm()
	const { mutate, isLoading, isError } = useSendCognitoOtp()

	const onSave = data => {
		const { email } = data
		mutate(
			{ email },
			{
				onSuccess: async data => {
					sessionStorage.setItem(AUTH_LOGIN_MODE, LS_LOGIN_MODE.EMAIL)
					onSendOtpSuccess(data, EMAIL_FORM_VIEW.OTP_VIEW)
				},
				onError: err => {
					console.log('error', err)
				},
			}
		)
	}

	return (
		<>
			<Heading fontWeight='900' fontSize='1.625rem' lineHeight='2.25rem'>
				Login Using Email
			</Heading>
			<Text fontWeight='500' fontSize='1rem' lineHeight='1.375rem'>
				Please enter your registred email ID
			</Text>
			<form onSubmit={handleSubmit(onSave)}>
				<VStack minH='5rem' minW='22rem' spacing={8} justifyContent='center'>
					<FormControl id='email' pt={2} borderRadius='sm'>
						<InputText
							fontWeight='400'
							fontSize='1.125rem'
							lineHeight='1.5rem'
							placeholder='Enter your email'
							borderRadius='0'
							border='none'
							borderBottom='1px solid #D9D9D9'
							_placeholder={{
								color: '#B1B1B1',
							}}
							variant='noOutlineInput'
							inputref={register('email', {
								pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
								required: true,
							})}
						/>
						{errors && errors['email'] && (
							<FormHelperText color='red.600' fontWeight='400' fontSize='sm'>
								Please provide valid email
							</FormHelperText>
						)}
					</FormControl>
					<HStack alignItems='center'>
						<ButtonCTA
							type='submit'
							bg='brand.800'
							color='#828282'
							size='md'
							minW='320px'
							borderRadius='22px'
							background='gray.600'
							border='1px solid #D9D9D9'
							_hover={{
								color: 'white',
								background:
									'linear-gradient(268.34deg, #139988 10.16%, #008A4B 102.89%)',
							}}
							fontWeight='900'
							fontSize='1rem'
							lineHeight='1.375rem'
							disabled={!!isLoading}
						>
							SEND OTP
						</ButtonCTA>
					</HStack>
					{isError && (
						<Text color='red.600' fontWeight='400' fontSize='sm'>
							No user found!
						</Text>
					)}
					{isLoading ? (
						<Stack
							my={4}
							justifyContent='center'
							alignItems='center'
							direction='column'
						>
							<Spinner size='lg' />
							<Text color='brand.800'>Please, wait...</Text>
						</Stack>
					) : null}
				</VStack>
			</form>
			<Box>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.QR)
					}}
				>
					{/* <Image src={greneLogo} maxW="1.375rem" mr={4} /> */}
					<Box mr={4}>
						<SVGIcon
							iconName='greenlogoSvg'
							svgProps={{
								width: '20',
								height: '19',
								viewBox: '0 0 20 19',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					Login using GRID App
				</Link>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.OTP)
					}}
				>
					<Icon as={BsPhoneVibrate} mr={4} w='1.375rem' h='1.375rem' />
					Login using Phone
				</Link>
				{/* <Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.ACTIVE_DIRECTORY)
					}}
				>
					<Icon as={AiOutlineWindows} mr={4} w='1.375rem' h='1.375rem' />
					Login using Active Directory
				</Link> */}
			</Box>
		</>
	)
}
